import { environment } from './environment';
import { OauthClient } from './providers/auth/lib/oauth';

const client = new OauthClient({
    clientId: environment.REACT_APP_PASSPORT_CLIENT_ID,
});

export { client };
